import axios from 'axios'
import { apiUrl } from 'common/config'

const axiosInstance = axios.create({
  baseURL: `${apiUrl}/`,
  withCredentials: true,
})

export default axiosInstance
